export default __webpack_public_path__ + "static/media/header_background.e4c8d6f7.png";